import React, { useState, useEffect } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import './AdminDiscountCodes.css';

function AdminDiscountCodes() {
  const [codes, setCodes] = useState([]);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [selectedCode, setSelectedCode] = useState(null);
  const [showHistory, setShowHistory] = useState(false);
  const [newCode, setNewCode] = useState({
    code: '',
    discountPercent: 10,
    maxUses: 1,
    expiresAt: '',
    allowedPlans: ['monthly', 'quarterly', 'semiannual']
  });

  useEffect(() => {
    fetchCodes();
    fetchStats();
  }, []);

  const fetchCodes = async () => {
    try {
      const response = await axios.get('https://api.chekidesara.ir/api/discount-codes');
      if (response.data.success) {
        setCodes(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching codes:', error);
      toast.error('خطا در دریافت کدهای تخفیف');
    } finally {
      setLoading(false);
    }
  };

  const fetchStats = async () => {
    try {
      const response = await axios.get('https://api.chekidesara.ir/api/discount-stats');
      if (response.data.success) {
        setStats(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching stats:', error);
    }
  };

  const viewHistory = async (code) => {
    try {
      const response = await axios.get(`https://api.chekidesara.ir/api/discount-codes/${code._id}/history`);
      if (response.data.success) {
        setSelectedCode(response.data.data);
        setShowHistory(true);
      }
    } catch (error) {
      toast.error('خطا در دریافت تاریخچه');
    }
  };

  const handleCreateCode = async () => {
    if (!newCode.code || !newCode.expiresAt) {
      toast.error('لطفاً تمام فیلدها را پر کنید');
      return;
    }

    try {
      const response = await axios.post('https://api.chekidesara.ir/api/discount-codes', newCode);
      if (response.data.success) {
        toast.success('کد تخفیف با موفقیت ایجاد شد');
        setShowForm(false);
        setNewCode({ code: '', discountPercent: 10, maxUses: 1, expiresAt: '', allowedPlans: ['monthly', 'quarterly', 'semiannual'] });
        fetchCodes();
        fetchStats();
      }
    } catch (error) {
      toast.error(error.response?.data?.message || 'خطا در ایجاد کد تخفیف');
    }
  };

  const handleDeleteCode = async (id) => {
    if (window.confirm('آیا از حذف این کد تخفیف مطمئن هستید؟')) {
      try {
        await axios.delete(`https://api.chekidesara.ir/api/discount-codes/${id}`);
        toast.success('کد تخفیف حذف شد');
        fetchCodes();
        fetchStats();
      } catch (error) {
        toast.error('خطا در حذف کد تخفیف');
      }
    }
  };

  if (loading) {
    return <div className="discount-loading">در حال بارگذاری...</div>;
  }

  return (
    <div className="admin-discount-codes">
      {/* آمار */}
      <div className="discount-stats">
        <div className="stat-card">
          <h3>{stats?.totalCodes || 0}</h3>
          <p>کل کدهای تخفیف</p>
        </div>
        <div className="stat-card">
          <h3>{stats?.totalUsed || 0}</h3>
          <p>تعداد دفعات استفاده</p>
        </div>
        <div className="stat-card">
          <h3>{stats?.activeCodes || 0}</h3>
          <p>کدهای فعال</p>
        </div>
      </div>

      {/* آمار استفاده بر اساس پلن */}
      {stats?.usageByPlan && stats.usageByPlan.length > 0 && (
        <div className="plan-stats">
          <h4>آمار استفاده بر اساس پلن:</h4>
          <div className="plan-stats-grid">
            {stats.usageByPlan.map(item => (
              <div key={item._id} className="plan-stat-item">
                <span className="plan-name">
                  {item._id === 'monthly' ? 'ماهانه' : item._id === 'quarterly' ? 'سه ماهه' : 'شش ماهه'}
                </span>
                <span className="plan-count">{item.count} بار</span>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* هدر و دکمه افزودن */}
      <div className="discount-header">
        <h2>مدیریت کدهای تخفیف</h2>
        <button className="btn-add" onClick={() => setShowForm(!showForm)}>
          {showForm ? '✖ بستن فرم' : '+ ایجاد کد جدید'}
        </button>
      </div>

      {/* فرم ایجاد کد جدید */}
      {showForm && (
        <div className="discount-form">
          <input
            type="text"
            placeholder="کد تخفیف (مثال: SUMMER10)"
            value={newCode.code}
            onChange={(e) => setNewCode({ ...newCode, code: e.target.value.toUpperCase() })}
          />
          <input
            type="number"
            placeholder="درصد تخفیف"
            value={newCode.discountPercent}
            onChange={(e) => setNewCode({ ...newCode, discountPercent: parseInt(e.target.value) })}
          />
          <input
            type="number"
            placeholder="حداکثر تعداد استفاده"
            value={newCode.maxUses}
            onChange={(e) => setNewCode({ ...newCode, maxUses: parseInt(e.target.value) })}
          />
          <input
            type="datetime-local"
            value={newCode.expiresAt}
            onChange={(e) => setNewCode({ ...newCode, expiresAt: e.target.value })}
          />
          <select
            multiple
            value={newCode.allowedPlans}
            onChange={(e) => {
              const options = [...e.target.selectedOptions];
              const values = options.map(opt => opt.value);
              setNewCode({ ...newCode, allowedPlans: values });
            }}
          >
            <option value="monthly">ماهانه</option>
            <option value="quarterly">سه ماهه</option>
            <option value="semiannual">شش ماهه</option>
          </select>
          <button className="btn-save" onClick={handleCreateCode}>ذخیره کد</button>
        </div>
      )}

      {/* جدول کدهای تخفیف */}
      <div className="discount-table">
        <table>
          <thead>
            <tr>
              <th>کد تخفیف</th>
              <th>درصد تخفیف</th>
              <th>تعداد استفاده</th>
              <th>حداکثر استفاده</th>
              <th>پلن‌های مجاز</th>
              <th>تاریخ انقضا</th>
              <th>وضعیت</th>
              <th>تاریخچه</th>
              <th>عملیات</th>
            </tr>
          </thead>
          <tbody>
            {codes.length === 0 ? (
              <tr>
                <td colSpan="9" className="no-data">هیچ کد تخفیفی وجود ندارد</td>
              </tr>
            ) : (
              codes.map(code => (
                <tr key={code._id}>
                  <td className="code-cell">{code.code}</td>
                  <td>{code.discountPercent}%</td>
                  <td>{code.usedCount}</td>
                  <td>{code.maxUses}</td>
                  <td>
                    {code.allowedPlans?.map(p => 
                      p === 'monthly' ? 'ماهانه' : p === 'quarterly' ? 'سه ماهه' : 'شش ماهه'
                    ).join(', ') || 'همه'}
                  </td>
                  <td>{new Date(code.expiresAt).toLocaleDateString('fa-IR')}</td>
                  <td>
                    <span className={code.isActive && new Date(code.expiresAt) > new Date() ? 'status-active' : 'status-expired'}>
                      {code.isActive && new Date(code.expiresAt) > new Date() ? 'فعال' : 'منقضی'}
                    </span>
                  </td>
                  <td>
                    <button className="btn-history" onClick={() => viewHistory(code)}>📋</button>
                  </td>
                  <td>
                    <button className="btn-delete" onClick={() => handleDeleteCode(code._id)}>🗑️</button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* مودال تاریخچه */}
      {showHistory && selectedCode && (
        <div className="history-modal-overlay" onClick={() => setShowHistory(false)}>
          <div className="history-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="history-modal-close" onClick={() => setShowHistory(false)}>×</button>
            <h3>تاریخچه استفاده - {selectedCode.code}</h3>
            {selectedCode.usageHistory && selectedCode.usageHistory.length > 0 ? (
              <table className="history-table">
                <thead>
                  <tr>
                    <th>ایمیل کاربر</th>
                    <th>پلن</th>
                    <th>مبلغ (ریال)</th>
                    <th>تاریخ استفاده</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedCode.usageHistory.map((item, index) => (
                    <tr key={index}>
                      <td>{item.userEmail}</td>
                      <td>{item.plan === 'monthly' ? 'ماهانه' : item.plan === 'quarterly' ? 'سه ماهه' : 'شش ماهه'}</td>
                      <td>{item.amount?.toLocaleString()}</td>
                      <td>{new Date(item.usedAt).toLocaleDateString('fa-IR')}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p>هیچ استفاده‌ای ثبت نشده است</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default AdminDiscountCodes;